import React from 'react';

type EditIconProps = {
  onClick?: () => void;
  className?: string | undefined;
};

export const EditIcon: React.FC<EditIconProps> = ({
  onClick,
  className,
}: EditIconProps): JSX.Element => {
  return (
    <div className={className}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <g clipPath="url(#clip0)">
          <path
            d="M9.88074 2.68747L1.07732 11.4915C1.03303 11.5359 1.00105 11.592 0.985817 11.6523L0.0100416 15.5689C-0.0191466 15.6868 0.0154986 15.8122 0.10154 15.8982C0.166643 15.9633 0.25535 15.9993 0.346087 15.9993C0.373879 15.9993 0.402306 15.9959 0.429972 15.9889L4.34653 15.013C4.40757 14.9978 4.46303 14.9659 4.50732 14.9217L13.3115 6.11823L9.88074 2.68747Z"
            fill="#394577"
          />
          <path
            d="M15.4925 1.48694L14.5126 0.506972C13.8576 -0.147986 12.7161 -0.147352 12.0619 0.506972L10.8615 1.70737L14.2921 5.138L15.4925 3.93761C15.8197 3.61057 15.9999 3.17529 15.9999 2.71233C15.9999 2.24938 15.8197 1.8141 15.4925 1.48694Z"
            fill="#394577"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
